module.exports = __webpack_public_path__ + "img/logo_full.f5d7f5c0.png";